<template>
  <v-container>
    <div class="containerStyle" v-if="loader">
      <img id="loader" class="zoom" :src="img2" />
    </div>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11></v-flex>
    </v-layout>
    <v-layout row>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 md7 lg8 xs12 sm11>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="typeEstrategico == '1' ">
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h4 class="pull">{{tipodimension}}</h4>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <table class="table table-striped header-fixed">
                <thead>
                  <tr>
                    <th
                      style="text-align: center"
                      :class="header.size"
                      v-for="(header,index) in headers2"
                      :key="index"
                    >{{header.text}}</th>
                  </tr>
                  <tr>
                    <th
                      style="text-align: center"
                      :class="header.border"
                      v-for="(header,index) in headers"
                      :key="index"
                    >{{header.text}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in indicadores" :key="index">
                    <td style="text-align:left " :class="headers[0].size">{{item.nombreIndicador}}</td>
                    <td style="text-align:center " :class="headers[1].size">{{item.periodo}}</td>

                    <td style="text-align:center " :class="headers[2].size">{{item.cohorte1}}</td>
                    <td style="text-align:center " :class="headers[3].size">{{item.cohorte2}}</td>
                    <td style="text-align:center " :class="headers[4].size">{{item.cohorte3}}</td>
                    <td style="text-align:center " :class="headers[5].size">{{item.cohorte4}}</td>
                    <td style="text-align:center " :class="headers[6].size">{{item.cohorte5}}</td>

                    <td :class="headers[7].size">
                      <v-icon small class="mr-2" @click="openEditIndicador(item,index)">edit</v-icon>
                      <v-icon small class="mr-2" @click="viewDocument(item)">add</v-icon>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>

      <v-flex md1.5 lg1.5 xs0 sm0 hidden-sm-and-down>
        <v-layout>
          <v-flex>
            <v-navigation-drawer floating permanent stateless class="drawner" value="true">
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        @click="downloadFile(3)"
                        small
                        color="#4376a1"
                        class="button"
                      >Estudios de Opinión</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        @click="downloadFile(4)"
                        small
                        color="#4376a1"
                        class="button"
                      >Manual SAC</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn
                        @click="downloadFile(5)"
                        small
                        color="#4376a1"
                        class="button"
                      >Evaluación SAC</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="v-list-new">
                      <v-btn @click="formulas = true" small color="#4376a1" class="button">Formulas</v-btn>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
          </v-flex>
        </v-layout>

        <!-- <v-layout>
          <v-dialog v-model="asistencia" width="500px">
            <template v-slot:activator="{ on }"></template>
            <v-card>
              <v-card-title>
                <span class="headline">Asistencia DCA</span>
              </v-card-title>
              <div class="form-group">
                <label for="comment">Comenta tus inquietudes</label>
                <textarea class="form-control" rows="9" id="comment"></textarea>
              </div>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#ec6a12" flat="flat" @click="asistencia = false">Cerrar</v-btn>
                <v-btn color="#394049" flat="flat" @click="sendDge">Enviar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout> -->

        <v-layout>
          <v-dialog v-model="formulas" width="500px">
            <template v-slot:activator="{ on }"></template>
            <v-card>
              <v-card-title>
                <span class="headline">Formulas de cálculo</span>
              </v-card-title>
              <div class="form-group">
                <p class="pull-left" v-html="this.formulahtml"></p>
              </div>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" flat="flat" @click="formulas = false">Cerrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <!-- <v-layout row>
          <v-flex md10 lg10 xs12 sm11>
            <img :src="img3" class="image" @click="asistencia = true" />
          </v-flex>
        </v-layout> -->
      </v-flex>
    </v-layout>

    <v-layout>
      <v-dialog v-model="edit" width="600px">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span class="headline" v-if="!create">Editar Indicador</span>
            <span class="headline" v-if="create">Crear Indicador</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Cohorte/Periodos de observación</label>
                <input v-model="indicador.periodo" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Año 1</label>
                <input v-model="indicador.cohorte1" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Año 2</label>
                <input v-model="indicador.cohorte2" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Año 3</label>
                <input v-model="indicador.cohorte3" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Año 4</label>
                <input v-model="indicador.cohorte4" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Año 5</label>
                <input v-model="indicador.cohorte5" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat="flat" @click="edit = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="!create" @click="editIndicador()">Guardar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="create" @click="createObjetivo()">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout>
      <v-btn
        v-if="this.$session.getAll().userType == 'postgradodca'"
        color="#394049"
        @click="openAprobacion"
      >Aprobación DCa</v-btn>
      <v-btn
        v-if="this.$session.getAll().userType != 'postgradodca'"
        color="#394049"
        @click="openViewAprobacion()"
      >Estado de aprobación DCA</v-btn>

      <v-btn
        v-if="this.$session.getAll().userType == 'postgrado'"
        color="#394049"
        @click="openAprobacionPost"
      >Aprobación Programa</v-btn>
      <v-btn
        v-if="this.$session.getAll().userType != 'postgrado'"
        color="#394049"
        @click="openViewAprobacionPost()"
      >Estado de aprobación Programa</v-btn>

      <v-btn color="#394049"  dark  @click="video = true">
        <v-icon dark>video_library</v-icon>
      </v-btn>
    </v-layout>

    <v-layout>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-dialog v-model="aprobacion" width="500">
          <template v-slot:activator="{ on }"></template>
          <v-card class="v-card-dialog">
            <v-card-title v-if="create">
              <span class="headline">¿Desea aprobar la etapa?</span>
            </v-card-title>
            <v-card-title v-if="!create">
              <span class="headline">Estado de aprobación</span>
            </v-card-title>
            <v-layout v-if="!create">
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <h4 v-if="this.etapa.etapa2Dca">Aprobado por DCA</h4>
                <h4 v-if="!this.etapa.etapa2Dca">Aún no hay aprobación por parte de DCA</h4>
                <h4>{{etapa.fechaEtapa2}}</h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <label for="usr">Observación</label>
                <textarea
                  v-model="obsEtapa"
                  type="text"
                  rows="3"
                  class="form-control"
                  id="usr"
                  :disabled="this.$session.getAll().userType != 'postgradodca'"
                />
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" flat="flat" @click="aprobacion = false">Cerrar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgradodca'"
                color="red"
                flat="flat"
                @click="checkPro(false)"
              >desaprobar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgradodca'"
                color="#394049"
                flat="flat"
                @click="checkPro(true)"
              >aprobar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-dialog v-model="aprobacionPost" width="500">
          <template v-slot:activator="{ on }"></template>
          <v-card class="v-card-dialog">
            <v-card-title v-if="create">
              <span class="headline">¿Desea aprobar la etapa?</span>
            </v-card-title>
            <v-card-title v-if="!create">
              <span class="headline">Estado de aprobación</span>
            </v-card-title>
            <v-layout v-if="!create">
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <h4 v-if="this.etapa.etapa2Otro">Aprobado por Programa</h4>
                <h4 v-if="!this.etapa.etapa2Otro">Aún no hay aprobación por parte del programa</h4>
                <h4>{{etapa.fechaEtapa2Gral}}</h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <label for="usr">Observación</label>
                <textarea
                  v-model="obsEtapaPost"
                  type="text"
                  rows="3"
                  class="form-control"
                  id="usr"
                  :disabled="this.$session.getAll().userType != 'postgrado'"
                />
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" flat="flat" @click="aprobacionPost = false">Cerrar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgrado'"
                color="red"
                flat="flat"
                @click="checkPrograma(false)"
              >desaprobar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgrado'"
                color="#394049"
                flat="flat"
                @click="checkPrograma(true)"
              >aprobar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-dialog v-model="video" width="1000">
        <template v-slot:activator="{ on }"></template>
        <v-toolbar dark color="#4376a1">
          <v-btn icon dark @click="pauseVideo()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card class="v-card-dialog">
          <video controls id="myVideo">
            <source :src="video1" type="video/mp4" />
          </video>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>


<script>
import img1 from "../../../assets/BANNER_5.png";
import img3 from "../../../assets/nuevaasistenciadca.png";
import img2 from "../../../assets/LOGO USACH.png";
import video1 from "../../../assets/video2.mp4";
import dimensiones from "../../util/indicadores.json";

export default {
  data() {
    return {
      video: "",
      video1: video1,
      obsEtapaPost: "",
      aprobacionPost: "",
      nEtapa: 2,
      etapa: "",
      obsEtapa: "",
      create: "",
      aprobacion: "",
      dimension: "",
      tipodimension: " ",
      loader: true,
      img2: img2,
      formulahtml: `<b style="color: #ec6a12"> Tasa de Retención al Primer Año</b>:
      Para  calcular la tasa de retención de primer año,
      se debe calcular el cociente entre el número de estudiantes 
      que ingresan como alumnos de
      primer año a una carrera o programa en un año determinado y el número de esos 
      mismos estudiantes que se mantienen en la carrera al año siguiente.</br>
      <i>(N° Alumnos cohorte que permanecen al año siguiente / N° Alumnos cohorte original (de la carrera o programa)) *100 </i> </br></br>
      
      <b style="color: #ec6a12"> Tasa de Retención total por cohorte</b>:
      Para  calcular la tasa de retención total, se debe calcular el cociente entre los estudiantes que ingresan como alumnos de primer año a  una carrera o programa en un año determinado y la suma del número de estudiantes actualmente matriculados, egresados sin titularse y titulados de dicha cohorte. 						
.</br>
      <i>((N° alumnos de la cohorte original matriculados a la fecha + N° egresados (no titulados) de la cohorte a la fecha + N° titulados de la cohorte a la fecha) / N° Cohorte original ) * 100.</i> </br></br>
      
      <b style="color: #ec6a12"> Tasa de Titulación por cohorte</b>:
      Se calcula el cociente entre el número de alumnos titulados hasta la fecha en una carrera y el número de alumnos de la cohorte original. </br>
      <i>(N° Titulados al año siguiente del tiempo teórico de duración de la carrera / N° Alumnos Cohorte) * 100.</i> <br><br>
      
      <b style="color: #ec6a12"> Tasa de titulación oportuna por cohorte</b>:
      Se calcula el cociente entre el número de alumnos titulados al año siguiente del tiempo teórico de duración de una carrera y el número   de alumnos de la cohorte  original.</br>
      <i>(N° Titulados al año siguiente del tiempo teórico de duración de la carrera / N° Alumnos Cohorte) * 100. </i> </br></br>`,
      formulas: "",
      img3: img3,
      dimensiones: dimensiones,
      asistencia: false,
      create: false,
      edit: false,
      index: "",
      tipodimension: "",
      dialog: false,
      indicador: {
        descripcionIndicador: "",
        cohorte3: ""
      },
      misionPropuesta:
        "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word, Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word",
      headers: [
        {
          text: "Indicadores",
          value: "name",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3",
          border: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        },
        {
          text: "Periodo",
          value: "name",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3",
          border: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        },

        {
          text: "Año 1",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1 ",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },
        {
          text: "Año 2",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1 ",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },
        {
          text: "Año 3",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1 ",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },

        {
          text: "Año 4",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1 ",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },
        {
          text: "Año 5",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1 ",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },

        {
          text: "Editar",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        }
      ],

      headers2: [
        {
          text: "",
          value: "name",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3"
        },
        {
          text: "",
          value: "name",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3"
        },

        {
          text: "Últimos 5 años/cohortes",
          value: "muy desacuerdo",
          size: "col-md-5 col-lg-5 col-sm-5 col-xs-5 th-border"
        },

        {
          text: "",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        }
      ],

      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      filesDca: "",
      img1: img1,

      indicadores: [],
      right: null
    };
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      this.loader = true;
      this.initComponent();
    }
  },

  created() {
    //console.log("aqui va el nombreeee");
    this.initComponent();
    this.getFile();
  },
  methods: {
    redirect(index) {
      this.typeEstrategico = index;
    },

    initComponent() {
      this.dimension = 0;
      this.getIndicadores();
      this.initObservacionGral();
    },

    sendDge() {
      this.asistencia = false;
      alert("Tus inquietudes han sido enviadas, pronto te contactaremos.");
    },

    getIndicadores() {
      //console.log("jhdkjahdkjhakjdhajkshdkjashdkjas: " + idDimension)
      //console.log("ccCompelte: " + this.$session.getAll().ccData.id)
      axios
        .get(
          process.env.ROOT_API +
            "/indicador/getAllByCodigoAndCarrera?idCarrera=" +
            this.$session.getAll().ccData.id +
            "&codigo=" +
            this.$route.params.id,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.indicadores = response.data;
          this.tipodimension = response.data[0].nombreSeccionIndicador;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          console.error(error);
        });
    },

    viewDocument(item) {
      this.$router.push({
        name: "evidenciaIndicadoresDoc",
        params: { id: item.id }
      });
    },

    getFile() {
      axios
        .get(
          process.env.ROOT_API + "/uploadFileDcaEtc/getByCcValor?idCarrera=75",
          this.auth
        )
        .then(response => {
          this.filesDca = response.data;
          //console.log(this.filesDca);
          //console.log(this.filesDca["dca"][1]);
        })
        .catch(error => {
          console.error(error);
        });
    },

    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDca.dca[index]["path"]);
      var nameFile = this.filesDca.dca[index]["name"];
      //console.log(nameFile);
      if (pathFile != "") {
        axios
          .get(
            process.env.ROOT_API +
              "/uploadFileDcaEtc/downloadFile?dir=" +
              pathFile,
            {
              responseType: "arraybuffer",
              headers: { Authorization: "" + this.$session.get("jwt") }
            }
          )
          .then(response => {
            //console.log("archivo descargado ....");
            //console.log(response);
            this.forceFileDownload(response, nameFile);
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        alert("Contenido no disponible");
      }
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    updateOtros(propuesta) {
      this.dialog = false;
    },

    openEditIndicador(indicador, index) {
      this.create = false;
      this.edit = true;
      this.index = index;
      this.indicador = indicador;
    },

    opencreateObjetivo() {
      this.create = true;
      this.edit = true;
      this.indicador = {
        descripcionIndicador: "",
        cohorte3: ""
      };
    },

    editIndicador() {
      this.edit = false;
      axios
        .post(
          process.env.ROOT_API + "/indicador/updateIndicador",
          this.indicador,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.initComponent();
          alert("Indicador Editado");
        })
        .catch(error => {
          console.error(error);
          this.initComponent();
          alert("Error:" + error);
        });
    },

    openAprobacion() {
      this.aprobacion = true;
      this.create = true;
    },
    openViewAprobacion() {
      this.aprobacion = true;
      this.create = false;
    },

    openAprobacionPost() {
      this.aprobacionPost = true;
      this.create = true;
    },
    openViewAprobacionPost() {
      this.aprobacionPost = true;
      this.create = false;
    },

    initObservacionGral() {
      axios
        .get(
          process.env.ROOT_API +
            "/etapa/etapaUsuario?idPostgrado=" +
            this.$session.getAll().ccData.id,
          this.auth
        )
        .then(response => {
          //console.log("ANEXOS");
          //console.log(response.data);
          this.obsEtapa = response.data["comentarioEtapa" + this.nEtapa];
          this.obsEtapaPost =
            response.data["comentarioEtapa" + this.nEtapa + "Gral"];
          this.etapa = response.data;
          //console.log(this.obsEtapa);
        })
        .catch(error => {
          //console.log("ERROR ANEXOS");
          console.error(error);
          this.showAlert("error", error.response.data);
        });
    },

    checkPrograma(booleanValue) {
      this.aprobacionPost = false;
      this.etapa["comentarioEtapa" + this.nEtapa + "Gral"] = this.obsEtapaPost;
      this.etapa["etapa" + this.nEtapa + "Otro"] = booleanValue;
      var tipo = "";
      if (booleanValue) {
        tipo = "aprobada";
      } else {
        tipo = "desaprobada";
      }
      //console.log(this.nEtapa);
      axios
        .patch(
          process.env.ROOT_API +
            "/etapa/updateEtapaGral?etapaNum=" +
            this.nEtapa,
          this.etapa,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.initObservacionGral();
          alert("Etapa 2 ha sido " + tipo);
        })
        .catch(error => {
          console.error(error);
          this.initObservacionGral();
          alert("Error:" + error);
        });
    },

    checkPro(booleanValue) {
      this.aprobacion = false;
      this.etapa["comentarioEtapa" + this.nEtapa] = this.obsEtapa;
      this.etapa["etapa" + this.nEtapa + "Dca"] = booleanValue;
      var tipo = "";
      if (booleanValue) {
        tipo = "aprobada";
      } else {
        tipo = "desaprobada";
      }
      //console.log(this.nEtapa);
      axios
        .patch(
          process.env.ROOT_API +
            "/etapa/updateEtapaDca?etapaNum=" +
            this.nEtapa,
          this.etapa,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.initObservacionGral();
          alert("Etapa 2 ha sido " + tipo);
        })
        .catch(error => {
          console.error(error);
          this.initObservacionGral();
          alert("Error:" + error);
        });
    },

    createObjetivo() {
      //console.log(this.indicador.queHaremos);
      this.indicadores.push(this.indicador);
      this.edit = false;
    },

    replaceT(texto) {
      var newTexto = texto.replace(/\n/g, "<br />");
      //console.log(newTexto);
      return newTexto;
    },
    pauseVideo() {
      document.getElementById("myVideo").pause();
      this.video = false;
    }
  }
};
</script>


<style scoped>
.image {
  cursor: pointer;
}
.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 12px;
}

.table2 {
  height: 100px !important;
}

.v-card-new {
  margin-top: 50px;
  margin-bottom: 3%;
  margin-left: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #394049 !important;
  height: 230px !important;
  overflow-y: auto;
}

.v-card {
  height: auto !important;
  overflow-y: auto;
}

.td-color {
  background: #394049;
  height: 100%;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull-left {
  text-align: justify;
  padding: 5% !important;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.header-fixed {
  width: 100%;
}
.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}
.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 300px;
  width: 100%;
}

.header-fixed > tbody > tr > td,
.header-fixed > thead > tr > th {
  float: left;
  font-size: 11px;
  border-bottom: 0 !important;
}

.th-border {
  border: #ddd 1px solid !important;
}

.th {
  background-color: aqua !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

#myVideo {
  width: 100%;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/dca/indicadores/IndicadorEvidencia.vue